<template>
  <div id="property">
    <div class="header">
      <div v-on:click="back">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M0 0h24v24H0z"
            fill="none"
          />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></svg>
      </div>
      <div v-on:click="toggleFav">
        <img :src="getHeart()">
        <span :class="isFav?'red':'grey'">收藏</span>
      </div>
    </div>
    <div class="houseInfo">
      <h1>{{_.get(data,'property.buildingName','')}}</h1>
    </div>
    <div class="detailBox">
      <div class="leftBox">
        <div class="left carousel">
          <carousel
            :scrollPerPage="true"
            :perPage="1"
            :autoplay="true"
            class="property"
          >
            <slide
              v-for="v in images"
              v-bind:key="v._id"
            >
              <img :src="getUrl(v.url)">
            </slide>
          </carousel>
        </div>
        <div class="right row-1 general-info">
          <div class="row-1-1">
            <b>{{_.get(data,'property.buildingName','')}}</b>
            <div
              class="status"
              :class="data.status"
            >{{getStatusName(data.status)}}</div>
          </div>
          <div class="row-1-2">
            <span>{{getBlockFloorUnit(data)}}</span>
          </div>
          <div class="row-1-3">
            <div class="price">
              <div v-if="data.status==='forSellAndRent'">
                <div>HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
                <div>HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
              </div>
              <div v-if="data.status==='forSell'">HKD {{_.round(data.sellPrice)}}萬{{getSellPricePerFeet(data)}}</div>
              <div v-if="data.status==='forRent'">HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
              <div v-if="data.status==='forSellWithRent'">
                <div class="left">HKD {{_.round(data.sellPrice)}}萬{{getSellPricePerFeet(data)}}</div>
                <div class="right">HKD {{_.round(data.rentingPrice)}}{{getRentingPricePerFeet(data)}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="left row-2 meta">
          <div class="row-2-1">
            <div>
              <div>
                <img src="@/assets/web_icons/badroom.png">
                <span>睡房</span>
              </div>
              <span>{{data.property.bedroom}}</span>
            </div>
            <div>
              <div>
                <img src="@/assets/web_icons/livingroom.png">
                <span>客廳</span>
              </div>
              <span>{{data.property.livingroom}}</span>
            </div>
            <div>
              <div>
                <img src="@/assets/web_icons/bathroom.png">
                <span>浴室</span>
              </div>
              <span>{{data.property.bathroom}}</span>
            </div>
            <div>
              <div>
                <img src="@/assets/web_icons/balcony.png">
                <span>露台</span>
              </div>
              <span>{{data.property.terrace}}</span>
            </div>
            <div>
              <div>
                <img src="@/assets/web_icons/muilt_function_room_icon.png">
                <span>多功能房</span>
              </div>
              <span>{{data.property.multiFunctionalRoom}}</span>
            </div>
          </div>
          <div class="row-2-2">
            <div>
              <img src="@/assets/web_icons/view.png">
              <span>{{getCompassName(data.property.view)}}</span>
            </div>
            <div>
              <img src="@/assets/web_icons/interior_design.png">
              <span>{{getCompassName(data.property.decoration)}}</span>
            </div>
            <div>
              <img src="@/assets/web_icons/compass.png">
              <span>{{getCompassName(data.property.compass)}}</span>
            </div>
          </div>
          <div class="row-2-3">
            <div>
              <img src="@/assets/web_icons/grossarea.png">
              <span>{{_.get(data,'property.grossArea',0).toFixed(1)}}呎</span>
            </div>
            <div>
              <img src="@/assets/web_icons/netarea.png">
              <span>{{_.get(data,'property.netArea',0).toFixed(1)}}呎</span>
            </div>
            <div>
              <span>{{(_.get(data,'property.areaRate',0)*100).toFixed(1)+"%"}}</span>
            </div>

          </div>
        </div>
        <div
          class="left row-3 description"
          v-if="hasDescription()"
        >
          <h2 v-if="isDesktop()">房屋說明</h2>
          {{data.property.description}}
        </div>
        <div
          class="left row-4 map"
          v-if="loadMap"
        >
          <GmapMap
            :center="{lat:lat,lng:lng}"
            :zoom="17"
            style="width: 100%; height: 300px"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false
            }"
          >
            <GmapMarker :position="{lat:lat,lng:lng}" />
          </GmapMap>
        </div>
      </div>
      <div class="rightBox">
        <div
          class="row-1 general-info"
          v-if="isDesktop()"
        >
          <div class="row-1-1">
            <div class="price">
              <div v-if="data.status==='forSellAndRent'">
                <div>HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
                <div>HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
              </div>
              <div v-if="data.status==='forSell'">HKD {{_.round(data.sellPrice)}}萬{{getSellPricePerFeet(data)}}</div>
              <div v-if="data.status==='forRent'">HKD {{_.round(data.rentPrice)}}{{getRentPricePerFeet(data)}}</div>
              <div v-if="data.status==='forSellWithRent'">
                <div class="left">HKD {{_.round(data.sellPrice)}}萬{{getSellPricePerFeet(data)}}</div>
                <div class="right">HKD {{_.round(data.rentingPrice)}}{{getRentingPricePerFeet(data)}}</div>
              </div>
            </div>
            <div
              class="status"
              :class="data.status"
            >{{getStatusName(data.status)}}</div>

          </div>
          <div class="row-1-2">
            <span>{{getBlockFloorUnit(data)}}</span>
          </div>
        </div>
        <div class="right row-5 agent">
          <img
            class="agentPhoto"
            :class="_.get(data, 'agent.profileImageUrl')?'profile':'placeholder'"
            :src="getAgentProfilePic(data)"
          >
          <div>
            <span class="agentName">{{data.agent.name}}</span>
            <a
              class="callBtn"
              :href="`tel:+853${data.agent.phoneNumber}`"
            >
                <img src="@/assets/web_icons/phone_icon.png">
                <span style="padding-left:16px">{{data.agent.phoneNumber}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import agentPlaceholder from "@/assets/web_icons/agent_placeholder.png";
import heartGrey from "@/assets/web_icons/heart_grey.png";
import heartRed from "@/assets/web_icons/heart_red_filled.png";
export default {
  name: "property",
  computed: {
    _() {
      return _;
    }
  },
  methods: {
    hasDescription() {
      return !!_.get(this, "data.property.description");
    },
    isDesktop() {
      return this.$resize && this.$mq.above(769);
    },
    getLocalStorageObj() {
      return Object.keys(localStorage).reduce(function(obj, str) {
        obj[str] = localStorage.getItem(str);
        return obj;
      }, {});
    },
    toggleFav() {
      this.isFav = !this.isFav;
      if (this.isFav) {
        localStorage.setItem(
          `${this.$getConst("FAV_PREFIX")}${this.data._id}`,
          (+new Date()).toString()
        );
      } else {
        localStorage.removeItem(
          `${this.$getConst("FAV_PREFIX")}${this.data._id}`
        );
      }
    },
    getHeart() {
      return this.isFav ? heartRed : heartGrey;
    },
    back() {
      if (!this.fromRoute.name) {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
    getAgentProfilePic(d) {
      return _.get(d, "agent.profileImageUrl", agentPlaceholder);
    },
    getRentingPricePerFeet(d) {
      let ppf = _.get(d, "rentingPrice", 0) / _.get(d, "property.grossArea", 0);
      if (!isNaN(ppf)) {
        return `@${_.round(ppf, 2)} ${_.get(d, "rentCondition", "")}`;
      } else {
        return "";
      }
    },
    getRentPricePerFeet(d) {
      let ppf = _.get(d, "rentPrice", 0) / _.get(d, "property.grossArea", 0);
      if (!isNaN(ppf)) {
        return `@${_.round(ppf, 2)} ${_.get(d, "rentCondition", "")}`;
      } else {
        return "";
      }
    },
    getSellPricePerFeet(d) {
      let ppf = _.get(d, "sellPrice", 0) / _.get(d, "property.grossArea", 0);
      if (!isNaN(ppf)) {
        return `@${_.round(ppf * 10000, 2)}`;
      } else {
        return "";
      }
    },
    getBlockFloorUnit(d) {
      return [
        _.get(d, "property.block"),
        _.get(d, "property.floor"),
        _.get(d, "property.unit")
      ]
        .filter(a => a)
        .join("－");
    },
    getUrl(url) {
      if (url) {
        return `https://${url}`;
      } else {
        return "";
      }
    },
    getStatusName(s) {
      return this.$getConst("STATUS_MAPPING")[s];
    },
    getCompassName(s) {
      return this.$getConst("COMPASS_MAPPING")[s];
    },
    loadProperty(id) {
      axios
        .get(`https://api.topagentmo.com/api/advertiseProperties/${id}`)
        .then(res => res.data)
        .then(d => {
          this.data = d;
          this.loadLocation();
          this.images = _.get(d, "images", []);
          if (!this.images.length) {
            this.images = [
              {
                _id: "placeholder",
                url: "via.placeholder.com/500"
              }
            ];
          }
        })
        .catch(e => null);
    },
    loadLocation() {
      axios
        .get(
          `https://api.topagentmo.com/api/buildings/buildingName/${_.get(
            this.data,
            "property.buildingName"
          )}`
        )
        .then(res => res.data)
        .then(d => {
          this.lng = _.get(d, "location.coordinates.0");
          this.lat = _.get(d, "location.coordinates.1");
          this.loadMap = true;
        })
        .catch(e => null);
    }
  },
  data() {
    return {
      data: {
        property: {},
        agent: {}
      },
      images: [],
      isFav: false,
      lat: 22.1982355,
      lng: 113.5279705,
      loadMap: false,
      fromRoute: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from;
    });
  },
  mounted() {
    const pid = this.$route.params.id;
    if (`${this.$getConst("FAV_PREFIX")}${pid}` in this.getLocalStorageObj()) {
      this.isFav = true;
    }
    this.loadProperty(pid);
  },
  components: {}
};
</script>
<style lang="scss">
@media (max-width: 768px) {
  .VueCarousel-pagination {
    position: absolute;
    bottom: 0;
    .VueCarousel-dot {
      background-color: white !important;
      opacity: 0.7;
      transition: all 0.2s;
      outline: none !important;
    }
    .VueCarousel-dot--active {
      opacity: 1;
    }
  }
}
@media (min-width: 769px) {
  .VueCarousel.property {
    .VueCarousel-wrapper {
      @media all and (min-width: 769px) and (max-width: 1000px) {
        width: 100%;
      }
      background-color: #f8f8f8;
      width: 670px;
    }
  }
}
</style>

<style lang="scss" scoped>
.header {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  > div {
    user-select: none;
    > span.red {
      color: #ca5353 !important;
    }
    &:hover {
      transform: scale(1.005) translateZ(0);
      font-weight: bold;
    }
    cursor: pointer;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    display: flex;
    height: 40px;
    > img {
      height: 28px;
      margin-right: 3px;
    }
  }
}
.houseInfo {
  display: none;
}
.VueCarousel-slide {
  position: relative;
  background: white;
  color: #fff;
  font-family: Arial;
  font-size: 24px;
  text-align: center;
  // background-image: url(https://picsum.photos/1000/1000);
  background-size: cover;
  background-color: black;
  background-position: center;
  // height: 560px; //desktop
  height: 230px;
  > img {
    width: auto;
    height: 100%;
  }
}
.row-2.meta {
  img {
    height: 24px;
    width: 24px;
  }
  display: flex;
  flex-direction: column;
  .row-2-1 {
    display: flex;
    justify-content: space-between;
    border-top: solid 1px black;
    padding: 0 16px;
    padding-top: 8px;
    > div {
      position: relative;
      > div {
        display: flex;
        flex-direction: column;
      }
      > span {
        position: absolute;
        left: 27px;
        top: 0;
      }
    }
  }
  .row-2-2 {
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px black;
    padding: 8px 16px;
    padding-bottom: 8px;
  }
  .row-2-3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    > div {
      display: flex;
      align-items: center;
      > img {
        margin-right: 3px;
      }
    }
  }
}

.row-1.general-info {
  padding: 16px;
  .row-1-1 {
    display: block;
    height: 40px;
    > b {
      font-size: 28px;
      float: left;
    }
    > div {
      display: inline-block;
      &.status {
        float: right;
        height: 28px;
        line-height: 28px;
        width: 3rem;
        font-size: 1rem;
        color: white;
        padding: 4px 6px;
        border-radius: 3px;
      }
      &.status.forSellAndRent {
        background-color: #299283;
      }
      &.status.forSell {
        background-color: #4ed85d;
      }
      &.status.forRent {
        background-color: #536cca;
      }
      &.status.forSellWithRent {
        background-color: #427182;
      }
    }
  }
  .row-1-2 {
    display: block;
    text-align: left;
    margin: 8px 0;
  }
  .row-1-3 {
    display: block;
    text-align: left;
    font-weight: bold;
    div.price {
      > div {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
@media all and (min-width: 769px) and (max-width: 1000px) {
  .detailBox {
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  #property {
    background-color: #fff;
  }
  .carousel {
    height: 230px;
  }

  .row-3.description {
    text-align: left;
    padding: 16px;
  }
}
@media (min-width: 769px) {
  #property {
    max-width: 1000px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 10px;
    .houseInfo {
      display: block;
      margin-bottom: 15px;
      h1 {
        text-align: left;
      }
    }
    .detailBox {
      display: flex;
      position: relative;
      .leftBox {
        flex: 0 0 670px;
        margin-right: 10px;
        .right {
          display: none;
        }
      }
      .rightBox {
        flex: 0 0 320px;
        .left {
          display: none;
        }
      }
    }
    .row-2.meta {
      padding: 15px 25px;
      background-color: white;
      margin-top: 10px;
    }
    .row-3.description {
      padding: 15px 25px;
      background-color: white;
      margin-top: 10px;
      text-align: left;
      h2 {
        margin-top: 0;
      }
    }
    .row-4.map {
      margin-top: 10px;
    }
    .row-1.general-info {
      padding: 15px 20px;
      background: #fff;
      padding-bottom: 5px;
      background-color: white;

      .row-1-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        > .price {
          font-size: 18px;
          font-weight: bold;
        }
      }
      .row-1-2 {
        padding-left: 10px;
      }
    }
    .row-5.agent {
      padding: 15px 25px;
      background-color: white;
      margin-top: 10px;
      // text-align: left;
    }
    .VueCarousel-slide {
      background-color: #f8f8f8;
      height: 440px; //desktop
    }
  }
}
.row-5.agent {
  display: flex;
  padding: 16px;
  > img.agentPhoto {
    &.placeholder {
    }
    margin-right: 16px;
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 50%;
  }
  > div {
    font-size: 1.35rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .callBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 16px;
      text-decoration: none;
      color: #ffffff;
      > img {
        height: 2rem;
        width: auto;
        filter: invert(100);
      }
      position: relative;
      border-radius: 30px;
      line-height: 40px;
      width: 10rem;
      background-image: linear-gradient(to right, #2111b9 0%, #8e4cd2 100%);
    }
  }
}
</style>
